<template>
  <div id="comic-div">
    <!--
      This is using tricks.
      When 'v-if' is processed for the first time, the condition is satisfied, the DOM is created with delay.
      'v-show' has a role only to switch display.
      Use this to prefetch the next image.
      As a result, the end user can quickly display the next page when reading comics.
    -->
    <img v-for="(url, index) in imageList"
         v-if="shouldPrefetchImage(index)"
         v-show="shouldShowImage(index)"
         :class="isMobile() ? 'img-fluid':'comic-page-position'"
         draggable="false"
         ondragstart="return false;"
         v-bind:src="url"/>

    <!--
      Hack to prevent saving by image D&D or right click.
      Place 1px transparent GIF image on the comic image.
    -->
    <img src="/koreyomo/static/assets/images/comic.gif" class="comic-page-position" />
  </div>
</template>

<script>
  const PREFETCH_COUNT = 1

  export default {
    name: "ComicPage",
    props: {
      imageList: {
        type: Array,
        default: () => []
      },
      imageIndex: {
        type: Number,
        default: () => 0
      }
    },
    methods: {
      shouldShowImage(index) {
        return index === this.imageIndex
      },
      shouldPrefetchImage(index) {
        return (index >= this.imageIndex && index <= this.imageIndex + PREFETCH_COUNT)
      },
    }
  }
</script>

<style scoped>
  .comic-page-position {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  
</style>


// WEBPACK FOOTER //
// src/components/ComicPage.vue